import { useTravelataApiService } from '@/shared/composables/useTravelataApiService';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';
import { getClientUuid } from '@/shared/lib/clientUuid';
import type { Country, Destination } from '@/shared/model';
import { adaptDestinations } from './adapter';
import type { ApiOption } from './types';

const cache = new Map<string, ApiOption[]>();

export function clearOptionsCache(): void {
  cache.clear();
}

export async function getOptions(term: string, countries: Country[] = [], url?: string): Promise<Destination[]> {
  try {
    const apiService = useTravelataApiService();
    const config = useTravelataAppConfig();

    const source = url || config.intelligentSearch;
    const query = term.toLowerCase();
    // Справочник часть ключа: один терм в разных словарях даёт разные направления
    const key = `${source}::${query}`;

    const cached = cache.get(key);
    if (cached !== undefined) {
      return adaptDestinations(cached, countries);
    }

    const response = await apiService.get<unknown>(source, {
      params: { term: query, clientUUID: getClientUuid() },
    });

    const list: ApiOption[] = Array.isArray(response)
      ? (response as ApiOption[])
      : response && Array.isArray((response as { result?: unknown }).result)
      ? (response as { result: ApiOption[] }).result
      : [];

    cache.set(key, list);
    return adaptDestinations(list, countries);
  } catch {
    return [];
  }
}
